__turbopack_context__.v({
  "playButton": "VideoSlideMbaLp-module-scss-module__kwTqTG__playButton",
  "preview": "VideoSlideMbaLp-module-scss-module__kwTqTG__preview",
  "readMoreBtn": "VideoSlideMbaLp-module-scss-module__kwTqTG__readMoreBtn",
  "thumbnail": "VideoSlideMbaLp-module-scss-module__kwTqTG__thumbnail",
  "video": "VideoSlideMbaLp-module-scss-module__kwTqTG__video",
  "videoContainer": "VideoSlideMbaLp-module-scss-module__kwTqTG__videoContainer",
  "videoFullscreen": "VideoSlideMbaLp-module-scss-module__kwTqTG__videoFullscreen",
});
